import backend from "../../../../backend/backend";
import label from "../../../../i18n/label";
import Notify from "../../../shared/Notify";
import { KBaseActions } from "./kbaseReducer";

export const loadKBases = (intl, workspaceId, onSuccess, onError) => {
  return (dispatch) => {
    backend
      .getKBases(workspaceId)
      .then((data) => {
        dispatch({ type: KBaseActions.LIST_LOADED, list: data });
        onSuccess && onSuccess(data);
      })
      .catch((err) => {
        onError && onError(err);
        console.error("Failed to load knowledge bases", err);
        Notify.error(label(intl, "error_unexpected"));
      });
  };
};

export const createKBase = (intl, workspaceId, name, onSuccess, onError) => {
  return (dispatch) => {
    backend
      .createKBase(workspaceId, name)
      .then((data) => {
        dispatch({ type: KBaseActions.LIST_COUNTER_INC });
        onSuccess && onSuccess(data);
      })
      .catch((err) => {
        onError && onError(err);
        console.error("Failed to create knowledge base", err);
        Notify.error(label(intl, "error_unexpected"));
      });
  };
};

export const loadKBase = (intl, workspaceId, kbaseId, onSuccess, onError) => {
  return (dispatch) => {
    backend
      .getKBase(workspaceId, kbaseId)
      .then((data) => {
        dispatch({ type: KBaseActions.KBASE_LOADED, kbase: data });
        onSuccess && onSuccess(data);
      })
      .catch((err) => {
        onError && onError(err);
        console.error("Failed to load knowledge base", err);
        Notify.error(label(intl, "error_unexpected"));
      });
  };
};

export const updateKBase = (intl, workspaceId, kbaseId, data, onSuccess, onError) => {
  return (dispatch) => {
    backend
      .updateKBase(workspaceId, kbaseId, data)
      .then((result) => {
        dispatch({ type: KBaseActions.LIST_COUNTER_INC });
        onSuccess && onSuccess(result);
      })
      .catch((err) => {
        onError && onError(err);
        console.error("Failed to update knowledge base", err);
        Notify.error(label(intl, "error_unexpected"));
      });
  };
};

export const deleteKBase = (intl, workspaceId, kbaseId, onSuccess, onError) => {
  return (dispatch) => {
    backend
      .deleteKBase(workspaceId, kbaseId)
      .then((data) => {
        dispatch({ type: KBaseActions.LIST_COUNTER_INC });
        onSuccess && onSuccess(data);
      })
      .catch((err) => {
        onError && onError(err);
        console.error("Failed to delete knowledge base", err);
        Notify.error(label(intl, "error_unexpected"));
      });
  };
};
